export default "__VITE_ASSET__gw45duMO__"